import menuConfig from "../components/navigation/nav-config";

export const targetOptions = ["tools", "researchs","reward","portfolio"];

export const checkPagePermission = (tools:any,target:string) => {
    // console.log("tools",tools)
    if (tools[target]) {
        return true;
    }
    return false;
}


export const checkIsIframePage = (url:string) =>{
    //loop sidebarSource can chekc isIframe boolen
    let isIframe = false;

    for(let i=0;i<menuConfig.length;i++){
        let menu = menuConfig[i];

        if(menu.url == url){
            if(menu.isIframe){
                isIframe = menu.isIframe;
            }
            break;
        }

        if(menu.subMenu){
            for(let j=0;j<menu.subMenu.length;j++){
                let subMenu = menu.subMenu[j];
                if(subMenu.url == url){
                    if(subMenu.isIframe){
                        isIframe = subMenu.isIframe;
                    }
                    break;
                }
            }
        }
       
    }

    return isIframe
}
